class ZaoudDetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('.search-modal__close-button')?.addEventListener('click', this.close.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.detailsContainer.hasAttribute('open') ? this.close() : this.open();
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    window.setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent);
    }, 0);
    document.body.classList.add('overflow-hidden');
    document.dispatchEvent(new CustomEvent('zaoud:mega-nav:close'));
    const input = this.querySelector('input:not([type="hidden"])');
    if (input) input.focus();
  }

  close(focusToggle = true) {
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if (focusToggle) this.summaryToggle.focus();
  }
}

if (!customElements.get('details-modal')) {
  customElements.define('details-modal', ZaoudDetailsModal);
}
